import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import {
  TbZodiacAquarius,
  TbZodiacPisces,
  TbZodiacAries,
  TbZodiacTaurus,
  TbZodiacGemini,
  TbZodiacCancer,
  TbZodiacLeo,
  TbZodiacVirgo,
  TbZodiacLibra,
  TbZodiacScorpio,
  TbZodiacSagittarius,
  TbZodiacCapricorn,
} from 'react-icons/tb';
import styles from './FooterZodiacIconCycle.module.css';

const zodiacIcons = [
  TbZodiacAries,
  TbZodiacTaurus,
  TbZodiacGemini,
  TbZodiacCancer,
  TbZodiacLeo,
  TbZodiacVirgo,
  TbZodiacLibra,
  TbZodiacScorpio,
  TbZodiacSagittarius,
  TbZodiacCapricorn,
  TbZodiacAquarius,
  TbZodiacPisces,
];

const FooterZodiacIconCycle = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % zodiacIcons.length);
    }, 1800);
    return () => clearInterval(timer);
  }, []);

  const IconComponent = zodiacIcons[index];

  return (
    <div className={styles.wrapper}>
      <div className={styles.circle}>
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.4 }}
            className={styles.icon}
          >
            <IconComponent />
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FooterZodiacIconCycle;
